// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce1ff97a","455":"e3065f8a"}[chunkId] + ".chunk.js";
};